var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diagnosis-bg"},[_c('canvas',{ref:"particlesCanvas",attrs:{"id":"diagnosis-particles"}}),_c('div',{staticClass:"diagnosis-grid-bg"}),_c('div',{staticClass:"diagnosis-scanline"})])
}
var staticRenderFns = []

export { render, staticRenderFns }